<lx-selector-field-container
  i18n-label
  label="Location"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="locationSelector_field"
>
  {{ selectedValue ? selectedValue?.schoolName : emptySelectionMsg }}
</lx-selector-field-container>

<lx-side-panel i18n-title title="Select a location" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" size="large" data-qa="locationSelector_sidePanel">
  <lx-location-selector
    [visible]="dialogVisible"
    [groupedSchoolLocations]="groupedSchoolLocations"
    (selectedSchoolLocationChanged)="handleSelectedValue($event)"
    data-qa="locationSelector"
  ></lx-location-selector>
</lx-side-panel>
